import { Stack } from '@mui/material';
import { TourProvider } from 'providers';
import { Outlet } from 'react-router-dom';
import { useState, Suspense } from 'react';

import Navbar from './Navbar';
import Footer from './Footer';
import Sidebar from './Sidebar';

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <TourProvider>
        <Sidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
        <Stack
          flexGrow={1}
          minHeight="calc(100vh)"
          pl={{
            xs: 0,
            lg: 40.25, // 320px Sidebar Width
          }}
          pr={{
            xs: 0,
            lg: 0.25, // 320px Sidebar Width
          }}
          pb={{
            xs: 8, // 64px Footer Height
            sm: 0,
          }}
        >
          <Navbar onOpenSidebar={() => setOpen(true)} />
          <Suspense>
            <Outlet />
          </Suspense>
          <Footer />
        </Stack>
      </TourProvider>
    </>
  );
}
